<h5>Portes de Beneficiário</h5>
<p>Exibe a lista de Portes de Beneficiários que estão disponíveis no sistema FG2, sendo o Porte configuravél por modalidade de fundo no Menu Configuração Cestas.</p>

<app-porte-beneficiario-listagem
    *ngIf="pesquisado && portes.length > 0"
    [portes]="portes"
    [atributosPaginacao]="atributosPaginacaoComponenteListagem"
></app-porte-beneficiario-listagem>